<template>
  <div 
    :id="id" 
    class="modal fade inactive" 
    data-backdrop="false" 
    tabindex="-1">
    <div 
      :class="width" 
      class="right white b-l">
      <div class="row-col">
        <a 
          v-if="showCloseButton"
          data-dismiss="modal" 
          class="pull-right text-muted text-lg p-a-sm m-r-sm">×</a>
        <div class="p-a b-b">
          <span class="h5">
            <slot name="header-text"/>
          </span>
        </div>
        <div class="row-row">
          <div class="row-body">
            <div class="row-inner">
              <slot name="body"/>
            </div>
          </div>
        </div>
        <div class="p-a b-t text-right">
          <button 
            :disabled="loading" 
            data-dismiss="modal" 
            class="btn btn-fw white">{{ cancelText }}</button>
          <slot name="footer"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            required: true,
        },

        width: {
            type: String,
            default: 'w-xxl',
        },

        cancelText: {
            type: String,
            default: 'Close',
        },

        loading: {
            type: Boolean,
            default: false,
        },

        showCloseButton: {
            type: Boolean,
            default: true,
        },
    },

    mounted() {
        this.registerEvent();

        $(this.$el).on('show.bs.modal', e => {
            $(document.body).addClass('modal-aside');
        });

        $(this.$el).on('hidden.bs.modal', e => {
            $(document.body).removeClass('modal-aside');
            this.$emit('modal-hidden');
        });
    },

    methods: {
        registerEvent() {
            this.$on('show', () => $(`#${this.id}`).modal('show'));
            this.$on('hide', () => $(`#${this.id}`).modal('hide'));
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/AsideModal.vue